// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/**\n* Colors\n*/\n.ant-checkbox-wrapper {\n  display: flex; }\n  .ant-checkbox-wrapper .ant-checkbox {\n    top: 0;\n    display: flex;\n    align-items: center; }\n    .ant-checkbox-wrapper .ant-checkbox:after {\n      display: none !important; }\n    .ant-checkbox-wrapper .ant-checkbox + span {\n      flex: 1 1;\n      padding-left: 24px; }\n", ""]);
// Exports
module.exports = exports;
